import { createReducer, on } from "@ngrx/store";
import { getStaticStore, getStaticStoreSuccess } from "../actions/static-store.action";
import { StaticStoreSource } from "../../domain/models/static-store-source.model";

export interface StaticStoreState {
    response: StaticStoreSource | null
}

export const initialState: StaticStoreState = {
    response: null
};

export const staticStoreReducer = createReducer(
    initialState,
    on(getStaticStore, (state) => ({ ...state, error: null })),
    on(getStaticStoreSuccess, (state, { response }) => ({ ...state, response, error: null }))
);
